import styled, { css } from 'styled-components';

import { pxToRem } from '../../../utils/styles';
import { ColorTypes } from '../../themes/_declarations/colors';

export const ElevatedWrapper = styled.div<{
  $background?: ColorTypes;
  $type: string;
  $widgetType?: string;
}>`
  &&& {
    ${({ $type, $widgetType }) =>
      $widgetType === 'modal' &&
      css`
        box-shadow: ${({ theme }) => theme.elevations[$type]};
        padding: ${pxToRem(24)};
      `}
    background-color: ${({ $background, theme }) =>
      $background && theme.colors[$background]};
  }
`;

export const SelectedCardContainer = styled.div`
  &&& {
    position: absolute;
    background: ${({ theme: { colors } }) => colors.success};
    width: ${pxToRem(24)};
    height: ${pxToRem(24)};
    right: ${pxToRem(-15)};
    top: ${pxToRem(-13)};
    border-radius: ${pxToRem(60)};
  }
`;

export const WrapperProduct = styled(ElevatedWrapper)<{
  $selected?: boolean;
  $widgetType?: string;
}>`
  &&& {
    border-radius: ${pxToRem(4)};
    ${({ $selected, $widgetType }) =>
      $widgetType === 'modal' &&
      css`
        border: ${$selected ? `${pxToRem(2)} solid black` : ''};
      `};
    display: flex;
    flex-direction: column;
    gap: ${pxToRem(16)};
    cursor: pointer;
    position: relative;
    width: ${pxToRem(896)};
    ${({ theme: { mediaQueries } }) =>
      (mediaQueries.isTablet || mediaQueries.isMobile) &&
      css`
        width: 100%;
      `}
  }
`;

export const HeaderProduct = styled.div`
  &&& {
    display: flex;
    justify-content: space-between;
  }
`;

export const Divider = styled.div`
  &&& {
    height: ${pxToRem(1)};
    background: ${({ theme: { colors } }) => colors.neutral300};
    margin-bottom: ${pxToRem(16)};
  }
`;

export const ControlsWrapper = styled.div<{ $widgetType?: string }>`
  &&& {
    display: flex;
    gap: ${pxToRem(48)};

    ${({ $widgetType, theme: { mediaQueries } }) =>
      $widgetType === 'modal' &&
      css`
        padding: ${pxToRem(24)};
        border-radius: ${pxToRem(4)};
        border: ${pxToRem(1)} solid ${({ theme }) => theme.colors.brand1};
       ${
         (mediaQueries.isTablet || mediaQueries.isMobile) &&
         css`
           gap: ${pxToRem(24)};
           flex-direction: column;
         `
       }}

      `}

    ${({ $widgetType }) =>
      $widgetType === 'embedded' &&
      css`
        gap: ${pxToRem(40)};
        flex-direction: column;
      `}
  }
`;

export const SpinnerContainer = styled.div`
  &&& {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
  }
`;

export const ErrorWrapper = styled.div<{ $widgetType?: string }>`
  &&& {
    ${({ $widgetType }) =>
      $widgetType === 'embedded'
        ? css`
            height: ${pxToRem(40)};
          `
        : css`
            padding: ${pxToRem(16)} 0;
          `}
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
`;

export const WrapperControlsTax = styled.div`
  &&& {
    display: flex;
    flex-direction: column;
    gap: ${pxToRem(20)};
  }
`;

export const ServicesTilesSection = styled.div`
  &&& {
    display: flex;
    flex-wrap: wrap;
    gap: ${pxToRem(10)};
    ${({ theme: { mediaQueries } }) =>
      (mediaQueries.isTablet || mediaQueries.isMobile) &&
      css`
        display: block;
      `}
  }
`;
export const ServiceTile = styled.div`
  &&& {
    flex: 1 1 calc(33.333% - 10px);
    box-sizing: border-box;
    text-align: center;
    padding: ${pxToRem(10)};
    max-width: 32%;
    box-shadow: ${({ theme }) => theme.elevations['3']};
    padding: ${pxToRem(24)} ${pxToRem(16)} ${pxToRem(24)} ${pxToRem(16)};
    overflow: hidden;
    text-overflow: clip;
    white-space: normal;
    word-wrap: break-word;
    align-content: center;
    ${({ theme: { mediaQueries } }) =>
      (mediaQueries.isTablet || mediaQueries.isMobile) &&
      css`
        width: 100%;
        max-width: 100%;
        margin-bottom: ${pxToRem(10)};
      `}
  }
`;

export const ServicePanel = styled.div`
  &&& {
    display: flex;
    flex-direction: column;
    gap: ${pxToRem(16)};
  }
`;

export const ServicePanelLeft = styled(ServicePanel)`
  &&& {
    flex: 1;
    flex-basis: 55%;
    display: flex;
    flex-direction: column;
    gap: ${pxToRem(24)}
      ${({ theme: { mediaQueries } }) =>
        (mediaQueries.isTablet || mediaQueries.isMobile) &&
        css`
          display: block;
        `};
  }
`;
export const ServicePanelRight = styled(ServicePanel)`
  &&& {
    flex: 1;
    border-left: ${pxToRem(1)} solid ${({ theme }) => theme.colors.textBody};
    margin-left: ${pxToRem(16)};
    padding-left: ${pxToRem(16)};
    align-items: center;
    justify-content: center;
    text-align: center;
    ${({ theme: { mediaQueries } }) =>
      (mediaQueries.isTablet || mediaQueries.isMobile) &&
      css`
        border: none;
        margin-left: 0;
        padding-left: 0;
        display: block;
      `}
  }
`;

export const ServiceTilesWrapper = styled.div`
  &&& {
    display: flex;
    ${({ theme: { mediaQueries } }) =>
      (mediaQueries.isTablet || mediaQueries.isMobile) &&
      css`
        display: block;
      `}
  }
`;

export const HeaderProductTile = styled.div`
  &&& {
    display: flex;
    justify-content: space-between;
  }
`;

export const OptionsWrapper = styled.div`
  &&& {
    display: flex;
    gap: ${pxToRem(10)};
    border: ${pxToRem(1)} solid ${({ theme }) => theme.colors.brand1};
    border-radius: ${pxToRem(4)};
    padding: ${pxToRem(12)} ${pxToRem(24)};
    align-items: center;
    justify-content: space-between;
    min-height: ${pxToRem(48)};
    ${({ theme: { mediaQueries } }) =>
      (mediaQueries.isTablet || mediaQueries.isMobile) &&
      css`
        flex-direction: column;

        ${({ theme }) =>
          theme.name === 'ecommerce' &&
          css`
        border-radius: 0;
        border-bottom: border: ${pxToRem(1)} solid ${theme.colors.brand1};
      `}
      `};
  }
`;

export const LegalNoteWrapper = styled.div`
  &&& {
  }
`;

export const OptionTile = styled.div`
  &&& {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${pxToRem(5)};
    ${({ theme: { mediaQueries } }) =>
      (mediaQueries.isTablet || mediaQueries.isMobile) &&
      css`
        justify-content: space-between;
        width: 100%;
      `}
  }
`;

export const IconWrapper = styled.div`
  &&& {
    margin-right: ${pxToRem(16)};
  }
`;

export const ContentSection = styled.div`
  &&& {
    display: flex;
    flex-direction: column;
    gap: ${pxToRem(16)};
    margin-bottom: ${pxToRem(16)};
  }
`;

export const ContentWrapper = styled.div`
  &&& {
    display: flex;
    flex-direction: column;
    gap: ${pxToRem(24)};
  }
`;
